import { COMPANY as C } from "../constants/company";

const contact = `${C.legalName}, ${C.address}, ${C.city}, ${C.country} · ${C.email} · ${C.phones[0]}`;

export const legalEsB = [
  {
    slug: "dmca",
    title: "DMCA / Derechos de Autor y Retiro de Contenido",
    intro: `${C.legalName} respeta los derechos de propiedad intelectual de terceros y espera que los usuarios de GOOX hagan lo mismo. Este documento explica cómo notificarnos una presunta infracción de derechos de autor y cómo gestionamos las solicitudes de retiro, conforme a la Digital Millennium Copyright Act (DMCA) de EE. UU., la Ley 23 de 1982 y la Ley 1915 de 2018 de Colombia y los tratados internacionales aplicables.`,
    sections: [
      { h: "1. Agente designado", body: [
        `Las notificaciones de derechos de autor deben enviarse a nuestro agente designado: Agente de Derechos de Autor, ${C.legalName}, ${C.address}, ${C.city}, ${C.country}. Correo: ${C.email} (asunto: \"Copyright Notice\").`,
      ]},
      { h: "2. Presentar una notificación de infracción", body: [
        "Para ser válida, tu notificación debe incluir:",
        "- Identificación de la obra protegida que se considera infringida.",
        "- La URL o ubicación precisa del material presuntamente infractor en GOOX.",
        "- Tu nombre, dirección, teléfono y correo electrónico.",
        "- Una declaración de que crees de buena fe que el uso no está autorizado por el titular, su agente o la ley.",
        "- Una declaración, bajo juramento, de que la información es exacta y de que eres el titular o estás autorizado para actuar en su nombre.",
        "- Tu firma física o electrónica.",
      ]},
      { h: "3. Nuestra respuesta", body: [
        "Al recibir una notificación válida retiraremos o deshabilitaremos el acceso al material con prontitud (objetivo: 48 horas), notificaremos al creador que lo publicó y registraremos la notificación. Los infractores reincidentes tendrán sus cuentas terminadas.",
      ]},
      { h: "4. Contranotificación", body: [
        "Un creador que considere que el material fue retirado por error puede presentar una contranotificación que contenga: identificación del material retirado, una declaración bajo juramento de que cree de buena fe que el retiro fue erróneo, aceptación de la jurisdicción de los tribunales competentes y su firma. Si el denunciante no inicia una acción judicial en 10 a 14 días hábiles, el material podrá ser restablecido.",
      ]},
      { h: "5. Solicitudes de retiro no relacionadas con derechos de autor", body: [
        "Las personas que aparezcan en contenido sin haber consentido su publicación, o que deseen retirar su consentimiento, pueden solicitar el retiro a través de la página de Quejas / Contacto. Estas solicitudes se priorizan y revisan en un máximo de 24 horas, y el contenido se deshabilita mientras se realiza la revisión.",
      ]},
      { h: "6. Declaraciones falsas", body: [
        "Presentar reclamaciones falsas a sabiendas puede generar responsabilidad por daños, incluidos costos y honorarios de abogados.",
      ]},
      { h: "7. Contacto", body: [contact] },
    ],
  },
  {
    slug: "age-safety",
    title: "Política de Edad y Seguridad",
    intro: `GOOX, operada por ${C.legalName}, es una plataforma exclusivamente para adultos. Esta Política resume los controles de verificación de edad y seguridad que aplican al Sitio de pre-lanzamiento y que se harán cumplir en la plataforma.`,
    sections: [
      { h: "1. Requisito de edad", body: [
        "El acceso al Sitio y a la plataforma está limitado a personas de al menos 18 años que hayan alcanzado la mayoría de edad en su jurisdicción. Los visitantes menores de 18 años deben abandonar el sitio de inmediato.",
      ]},
      { h: "2. Aviso de edad en el Sitio", body: [
        "El Sitio muestra un aviso 18+ en el encabezado, el hero y el pie de página. Durante la fase de pre-lanzamiento no se muestra contenido restringido por edad, y todas las imágenes son material de marca o conceptual apto para público general.",
      ]},
      { h: "3. Verificación de creadores (plataforma)", body: [
        "Antes de publicar, cada creador completará una verificación de identidad y edad mediante un proveedor KYC especializado, incluyendo validación de documento de identidad oficial y prueba de vida/selfie. Los creadores también deberán verificar a cada persona adicional que aparezca en su contenido y conservar los registros de consentimiento.",
      ]},
      { h: "4. Verificación de fans (plataforma)", body: [
        "Los fans confirmarán que son adultos durante el registro. Cuando lo exija la ley o los aliados de pago, GOOX aplicará medidas adicionales de verificación de edad, incluidas verificaciones basadas en documento o en tarjeta de pago.",
      ]},
      { h: "5. Controles de seguridad", body: [
        "- Herramientas de bloqueo y denuncia disponibles en cada perfil, publicación y mensaje.",
        "- Opciones de geobloqueo para creadores.",
        "- Marcas de agua y restricciones de descarga para reducir la filtración de contenido.",
        "- Prohibición de acordar encuentros presenciales a través de la plataforma.",
        "- Revisión dedicada de confianza y seguridad de las denuncias en 24 horas para categorías de alto riesgo.",
      ]},
      { h: "6. Protección de menores", body: [
        "GOOX tiene tolerancia cero con el material de abuso sexual infantil (CSAM). Cualquier material de este tipo o intento de publicarlo se retira de inmediato, se preserva como evidencia y se denuncia ante las autoridades competentes, incluida la Policía Nacional de Colombia (CAI Virtual) y organismos internacionales como NCMEC.",
      ]},
      { h: "7. Controles parentales", body: [
        "Padres y tutores pueden restringir el acceso a sitios para adultos mediante herramientas a nivel de dispositivo y de red. GOOX etiquetará la plataforma con metadatos compatibles con RTA para facilitar el software de filtrado.",
      ]},
      { h: "8. Contacto", body: [contact] },
    ],
  },
  {
    slug: "creator-terms",
    title: "Términos para Creadores",
    intro: `Estos Términos para Creadores regularán la relación entre ${C.legalName} y las personas o entidades que publiquen contenido y ofrezcan experiencias en la plataforma GOOX ("Creadores"). Complementan los Términos y Condiciones generales. El onboarding de creadores aún no está abierto; este documento se publica para describir el marco planeado.`,
    sections: [
      { h: "1. Elegibilidad", body: [
        "- Tener al menos 18 años y capacidad legal para contratar.",
        "- Completar la verificación de identidad, edad y (cuando aplique) de la empresa.",
        "- Proporcionar información tributaria y de pago exacta.",
        "- Las agencias y estudios deben identificar a cada creador que representan y tener acuerdos escritos con ellos.",
      ]},
      { h: "2. Relación independiente", body: [
        "Los Creadores son contratistas independientes y son los únicos responsables de su contenido, sus impuestos y el cumplimiento de la ley. Nada en estos Términos crea una relación laboral, de agencia o de sociedad.",
      ]},
      { h: "3. Contenido y licencias", body: [
        "Los Creadores conservan la propiedad de su contenido. Al publicar, el Creador otorga a GOOX una licencia no exclusiva y mundial para alojar, mostrar, distribuir y promocionar el contenido en la plataforma con el fin de prestar el servicio. Los Creadores garantizan que cuentan con todos los derechos y consentimientos necesarios, incluidos los de cada persona que aparece en el contenido.",
      ]},
      { h: "4. Precios y formatos", body: [
        "Los Creadores fijan los precios de sus suscripciones, desbloqueos, colecciones, series, lanzamientos exclusivos y lives dentro de los límites mínimos y máximos establecidos por GOOX. Todos los precios deben mostrarse claramente a los fans antes de la compra.",
      ]},
      { h: "5. Comisiones y pagos", body: [
        "GOOX retiene una comisión de plataforma expresada como porcentaje de cada transacción (publicada en el Creator Studio antes del onboarding). El monto restante, neto de costos de procesamiento de pagos e impuestos aplicables, se acredita al saldo del Creador y se paga según el calendario de pagos, sujeto a un período de retención para protección contra fraude y contracargos.",
      ]},
      { h: "6. Contracargos y reembolsos", body: [
        "Los reembolsos y contracargos atribuibles al contenido o la conducta del Creador podrán deducirse de su saldo. GOOX compartirá la evidencia pertinente con el Creador.",
      ]},
      { h: "7. Conducta", body: [
        "Los Creadores deben cumplir la Política de Contenido, la Política de Uso Aceptable y la Política de Edad y Seguridad; no deben solicitar pagos fuera de la plataforma por contenido ofrecido en GOOX; y no deben usar descripciones engañosas, escasez falsa ni prácticas manipuladoras.",
      ]},
      { h: "8. Suspensión y terminación", body: [
        "GOOX puede suspender o terminar cuentas de creadores por infracciones a estos Términos, a solicitud de autoridades o aliados de pago, o por razones de gestión de riesgo, con aviso cuando sea posible. Los saldos no disputados se pagarán una vez transcurrido el período de retención aplicable.",
      ]},
      { h: "9. Impuestos", body: [
        "Los Creadores son responsables de declarar y pagar los impuestos sobre sus ingresos. GOOX emitirá la documentación y aplicará las retenciones exigidas por la ley colombiana y la jurisdicción del Creador.",
      ]},
      { h: "10. Contacto", body: [contact] },
    ],
  },
  {
    slug: "acceptable-use",
    title: "Política de Uso Aceptable",
    intro: `Esta Política de Uso Aceptable aplica a todos los visitantes de ${C.domain} y, una vez lanzada, a todos los usuarios de la plataforma GOOX operada por ${C.legalName}.`,
    sections: [
      { h: "1. Te comprometes a no", body: [
        "- Usar el Sitio o la plataforma si eres menor de 18 años.",
        "- Proporcionar información falsa, suplantar a otros o crear cuentas en nombre de terceros sin autorización.",
        "- Subir, compartir o solicitar contenido prohibido por la Política de Contenido.",
        "- Acosar, amenazar, perseguir, exponer datos personales (doxing) o discriminar a creadores, fans o personal.",
        "- Grabar, descargar, capturar o redistribuir contenido fuera de la plataforma sin autorización.",
        "- Intentar eludir los sistemas de pago, verificación de edad o seguridad.",
        "- Usar bots, scrapers o herramientas automatizadas sin permiso escrito.",
        "- Introducir malware o interferir con el funcionamiento del servicio.",
        "- Usar la plataforma para lavado de activos, fraude o para concertar servicios sexuales presenciales.",
        "- Solicitar u ofrecer pagos fuera de la plataforma por contenido o experiencias ofrecidas en GOOX.",
      ]},
      { h: "2. Aplicación", body: [
        "Las infracciones pueden resultar en retiro de contenido, advertencias, suspensión temporal, terminación permanente, pérdida de saldos cuando la ley lo permita y denuncia ante las autoridades.",
      ]},
      { h: "3. Denuncias", body: [
        `Denuncia abusos a través de la página de Quejas / Contacto o en ${C.email}.`,
      ]},
      { h: "4. Contacto", body: [contact] },
    ],
  },
  {
    slug: "complaints",
    title: "Quejas / Contacto",
    intro: `${C.legalName} opera GOOX. Esta página indica los canales para contactarnos, presentar una queja, denunciar contenido o ejercer tus derechos de protección de datos.`,
    sections: [
      { h: "1. Datos de contacto", body: [
        `Empresa: ${C.legalName} · NIT ${C.nit}`,
        `Matrícula mercantil: No. ${C.registry}, ${C.chamber}`,
        `Dirección: ${C.address}, ${C.city}, ${C.country}`,
        `Correo electrónico: ${C.email}`,
        `Teléfonos: ${C.phones.join(" · ")}`,
        `Dirección para notificación judicial: ${C.address}, ${C.city}, ${C.country} · ${C.email}`,
      ]},
      { h: "2. Tipos de solicitudes", body: [
        "- Consultas generales y propuestas comerciales.",
        "- Quejas sobre el Sitio o, en el futuro, sobre transacciones, creadores o contenido.",
        "- Denuncias de contenido (contenido prohibido, material no consentido, derechos de autor).",
        "- Solicitudes de protección de datos (acceso, rectificación, supresión, revocación de la autorización).",
        "- Requerimientos de autoridades y aliados de pago.",
      ]},
      { h: "3. Tiempos de respuesta", body: [
        "- Denuncias que involucren menores o contenido no consentido: revisión en 24 horas.",
        "- Notificaciones de derechos de autor: gestión en 48 horas.",
        "- Consultas de protección de datos: 10 días hábiles; reclamos: 15 días hábiles (Ley 1581 de 2012).",
        "- Otras quejas: 5 días hábiles para una primera respuesta.",
      ]},
      { h: "4. Cómo presentar una queja", body: [
        `Escribe a ${C.email} con el asunto \"Queja\" e incluye: tu nombre y datos de contacto, una descripción del problema, la URL o referencia involucrada y cualquier evidencia de soporte. Confirmaremos la recepción y te daremos un número de radicado.`,
      ]},
      { h: "5. Escalamiento", body: [
        "Si no estás satisfecho con nuestra respuesta, puedes presentar una queja ante la Superintendencia de Industria y Comercio (SIC) en Colombia o ante la autoridad de consumo o protección de datos competente en tu jurisdicción.",
      ]},
    ],
  },
];
